cb.define([], function () {
  var AA_aa_gradelist_VM_Extend = {
    doAction: function (name, viewmodel) {
      if (this[name])
        this[name](viewmodel);
    },
    init: function (viewmodel) {
    	viewmodel.getGridModel().setShowCheckbox(false);//设置复选框不显示
    }
  }
  try {
    module.exports = AA_aa_gradelist_VM_Extend;
  } catch (error) {
  }
  return AA_aa_gradelist_VM_Extend;
});



// WEBPACK FOOTER //
// ./src/client/business/AA/AA_aa_gradelist_VM.Extend.js